import { History as OriginalHistory } from 'history';
import { extendHistory } from './extendHistory';
import { createHref } from './createHref';
import { isAbsoluteUrl } from './isAbsoluteUrl';

export type History = OriginalHistory & AdditionalProps;

export type HistoryAdapter = Omit<History, 'createHref' | 'back' | 'forward' | 'getNavigationMethod'> &
    Partial<AdditionalProps>;

export type GetNavigationMethod = (href: string) => NavigationMethod;

export type NavigationMethod =
    // Переход с помощью роутера
    | 'spa'
    // Нативный браузерный переход с перезагрузкой страницы
    | 'mpa'
    // Кастомный переход, например в webView
    | (() => void);

type AdditionalProps = {
    getNavigationMethod: GetNavigationMethod;
};

export function buildHistory(historyAdapter: HistoryAdapter): History {
    const { getNavigationMethod = getDefaultNavigationMethod } = historyAdapter;

    return extendHistory(historyAdapter, {
        back() {
            return historyAdapter.go(-1);
        },
        forward() {
            return historyAdapter.go(1);
        },
        createHref,
        getNavigationMethod,
    });
}

function getDefaultNavigationMethod(href: string) {
    return isAbsoluteUrl(href) ? 'mpa' : 'spa';
}
